import { type IconDefinition } from "@fortawesome/fontawesome-svg-core"

/* SOLID */
import {
  faArrowUpRight,
  faArrowRotateRight,
  faArrowRight,
  faBars,
  faBolt,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faDownToLine,
  faEarthAfrica,
  faEye,
  faFaceSmile,
  faHeadset,
  faMicrophone,
  faMicrophoneSlash,
  faMicrophoneSignalMeter,
  faLightbulb,
  faPlay,
  faPhoneHangup,
  faVolume,
  faVolumeSlash,
  faCircleXmark,
  faXmark,
  faUniversalAccess,
  faWaveformLines,
} from "@fortawesome/pro-solid-svg-icons"

/* THIN */
import {
  faLightbulb as fatLightbulb,
  faCircleInfo as fatCircleInfo,
  faCircleExclamation as fatCircleExclamation,
  faTriangleExclamation as fatTriangleExclamation,
  faCalendarClock as fatCalendarClock,
  faBolt as fatBolt,
  faTrophyStar as fatTrophyStar,
  faStars as fatStars,
  faQuestion as fatQuestion,
  faCircleQuestion as fatCircleQuestion,
  faCircleXmark as fatCircleXmark,
  faClock as fatClock,
  faDoorOpen as fatDoorOpen,
  faFaceSmile as fatFaceSmile,
  faMicrophone as fatMicrophone,
  faEarListen as fatEarListen,
  faPaperPlane as fatPaperPlane,
  faPersonRunningFast as fatPersonRunningFast,
  faUnicorn as fatUnicorn,
  faWandMagic as fatWandMagic,
  faWandMagicSparkles as fatWandMagicSparkles,
  faHandHoldingHeart as fatHandHoldingHeart,
  faUserClock as fatUserClock,
  faAlicorn as fatAlicorn,
  faPersonToDoor as fatPersonToDoor,
  faClockRotateLeft as fatClockRotateLeft,
  faArrowRight as fatArrowRight,
  faArrowsRotate as fatArrowsRotate,
  faGlobe as fatGlobe,
  faPartyHorn as fatPartyHorn,
  faUniversalAccess as fatUniversalAccess,
} from "@fortawesome/pro-thin-svg-icons"

/* LIGHT */
import { faRocket as falRocket } from "@fortawesome/pro-light-svg-icons"

/* DUOTONE */
import { faUnicorn as fadUnicorn } from "@fortawesome/pro-duotone-svg-icons"

export default [
  /* SOLID */
  faArrowUpRight,
  faArrowRotateRight,
  faArrowRight,
  faBars,
  faBolt,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faDownToLine,
  faEarthAfrica,
  faEye,
  faFaceSmile,
  faHeadset,
  faMicrophone,
  faMicrophoneSlash,
  faMicrophoneSignalMeter,
  faLightbulb,
  faPlay,
  faPhoneHangup,
  faVolume,
  faVolumeSlash,
  faCircleXmark,
  faXmark,
  faUniversalAccess,

  /* THIN */
  fatCircleInfo,
  fatCircleExclamation,
  fatCircleXmark,
  fatTriangleExclamation,
  fatCalendarClock,
  fatHandHoldingHeart,
  fatLightbulb,
  fatFaceSmile,
  fatMicrophone,
  fatBolt,
  fatStars,
  fatTrophyStar,
  fatQuestion,
  fatCircleQuestion,
  fatClock,
  fatUserClock,
  fatAlicorn,
  fatPersonToDoor,
  fatClockRotateLeft,
  fatArrowRight,
  fatArrowsRotate,
  fatGlobe,
  fatPartyHorn,
  fatUniversalAccess,
  faWaveformLines,

  /* LIGHT */
  falRocket,

  /* DUOTONE */
  fadUnicorn,
  fatDoorOpen,
  fatFaceSmile,
  fatMicrophone,
  fatEarListen,
  fatPaperPlane,
  fatPersonRunningFast,
  fatUnicorn,
  fatWandMagic,
  fatWandMagicSparkles,
] as IconDefinition[]

export const AF_ICON = "🦄"
